/*
 * @Author: czj
 * @Date: 2025-04-17 14:55:05
 * @Description: 
 * @FilePath: \sxtracellular-single-cell\src\locales\index.js
 */
import { createI18n } from 'vue-i18n';
import zh from './language/zh';
import en from './language/en';


const userLang = localStorage.getItem('lang') || 'zh';

const i18n = createI18n({
  legacy: false,  // 必须是 false，setup 语法才会生效
  locale: userLang,   // 默认语言
  fallbackLocale: 'en',// 回退语言
  messages: {
    zh,
    en
  }
});

export const langs = [ // 语言列表
  { key: 'zh', title: '中文' },
  { key: 'en', title: 'English' }
];

export default i18n;
